import FondationsFileUploadModel from './global/FondationsFileUploadModel';

export default class UserMediaProfilePictureModel extends FondationsFileUploadModel {
	static get path(): string {
		return '/user_media_profile_pictures';
	}
}
